import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { accountShape, bibShape, branchShape, libraryShape } from '@bibliocommons/bc-prop-types';
import HoldActions from 'app/actions/HoldActions';
import ModalActions from 'app/actions/ModalActions';
import { selectCurrentAccount } from 'app/selectors/AuthSelector';
import { selectHoldsTransactions, selectHoldError } from 'app/selectors/HoldsSelector';
import {
  selectCurrentLibrary,
  selectPickupBranches,
  selectActivePreferredBranches
} from 'app/selectors/LibrarySelector';

import PhysicalHoldButton from './PhysicalHoldButton';

export class PhysicalHoldButtonContainer extends React.PureComponent {
  render() {
    return <PhysicalHoldButton {...this.props} />;
  }
}

PhysicalHoldButtonContainer.propTypes = {
  bib: bibShape.isRequired,
  disabled: PropTypes.bool,
  currentAccount: accountShape,
  currentLibrary: libraryShape.isRequired,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  holdError: ImmutablePropTypes.map
};

const mapStateToProps = state => ({
  branches: selectPickupBranches(state),
  preferredBranches: selectActivePreferredBranches(state),
  currentAccount: selectCurrentAccount(state),
  currentLibrary: selectCurrentLibrary(state),
  holdsTransactions: selectHoldsTransactions(state),
  holdError: selectHoldError(state)
});

const mapDispatchToProps = dispatch => ({
  holdActions: bindActionCreators(HoldActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PhysicalHoldButtonContainer);
